import { useQuery } from '@tanstack/react-query';
import { useRequestSections } from '../../../api/request';
import { RootState } from '../../../redux/Store';
import { useSelector } from 'react-redux';
import { PersistHelper } from '../../../redux/persistHelper';
import customNotifications from './customNotifications';
import { useState } from 'react';

type GetLuggageTypeProps = {
  contextId?: string | number;
};

const useGetLuggage = () => {
  // const queryClient = useQueryClient();

  const { Luggage } = useRequestSections();
  const [isLuggageError, setIsLuggageError] = useState(false);

  const contextId = useSelector(
    (state: RootState) => state.contextId.contextId
  );
  const isAudit = useSelector((state: RootState) => state.contextId.isAudit);

  // Fetch script hash using the query
  const {
    data: luggageData,
    isLoading: isLuggageDataLoading,
    isFetching: isLuggagehDataFetching,
    refetch,
    error: luggageDataError,
  } = useQuery({
    queryKey: ['luggage', contextId],
    queryFn: async () => {
      const isPersisted = await PersistHelper.isDataPersisted(contextId);
      if (!isPersisted) {
        try {
          const response = await Luggage?.getLuggage(contextId);
          return JSON.stringify(response?.data);
        } catch (error: any) {
          const errorCode =
            error?.response?.status || error?.code || 'Unknown Error';
          customNotifications('Luggage data', errorCode);
          setIsLuggageError(true);
          //PersistHelper?.clearAllData();
        }
      }
      return null;
    },
    enabled: !!contextId,
    refetchOnWindowFocus: false,
    retry: 3,
  });

  return {
    luggageData,
    isLuggageDataLoading,
    isLuggagehDataFetching,
    refetch,
    luggageDataError,
    isLuggageError,
  };
};

export default useGetLuggage;
